import {
  getComponentSettings,
  getGlobalSettings,
  setComponentSettings,
  setGlobalSettings,
} from '@wix/bex-utils/@wix/ambassador-app-settings-v1-settings/http';
import { merge } from 'lodash';
import type { whenRequest } from '@wix/fe-essentials/http-client/testkit/client';
import type { AnyScenario } from '@wix/fe-essentials/http-client/testkit';

type WhenRequest = typeof whenRequest;

export type Settings = {
  [key: string]: Settings | string | number | boolean | null;
};

export interface AppSettings {
  settings: Settings;
}

export function appSettingsMocks(whenRequest: WhenRequest): AnyScenario[] {
  const db = {
    global: {
      settings: {},
    } as AppSettings,
    components: {} as Record<string, AppSettings | undefined>,
  };

  return [
    whenRequest(getGlobalSettings)
      .reply(200, async (data) => {
        const { host } = data;
        return {
          host,
          settings: {
            ...db.global.settings,
          },
        };
      })
      .persist(),

    whenRequest(getComponentSettings)
      .reply(200, async (data) => {
        const { host, componentId } = data;

        if (componentId == null) {
          throw new Error(
            `getComponentSettings: Invalid \`componentId\`, received: "${componentId}"`,
          );
        }

        return {
          host,
          settings: {
            ...db.components[componentId]?.settings,
          },
        };
      })
      .persist(),

    whenRequest(setGlobalSettings)
      .reply(200, async (data) => {
        const { host, settings } = data;

        merge(db.global.settings, settings);

        return {
          host,
          settings,
        };
      })
      .persist(),

    whenRequest(setComponentSettings)
      .reply(200, async (data) => {
        const { host, settings, componentId } = data;

        if (componentId == null) {
          throw new Error(
            `setComponentSettings: Invalid \`componentId\`, received: "${componentId}"`,
          );
        }

        const component = (db.components[componentId] ??= { settings: {} });

        merge(component.settings, settings);

        return {
          host,
          settings,
        };
      })
      .persist(),
  ];
}
